// Buffer глобально: gost89 і jkurwa звертаються до нього без імпорту
import { Buffer } from "buffer";
globalThis.Buffer ??= Buffer;
